import { EventEmitter } from "events";
import Dispatcher from "../Dispatcher";
import actionTypes from "../actions/ActionTypes";
const CHANGE_EVENT = "premiumAIChange";
let _fieldRelation = null;
let _allAIOCRGenericFields = [];
let _premiumAIFields = [];
let _newGenericField = null;
let _currentMonthRequestCount = { monthCount: 0, yearCount: 0, monthlyLimit: 0, yearlyLimit: 0 };
let _lastChange = "";
class AIOCRStore extends EventEmitter {
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }
  getFieldRelation() {
    return _fieldRelation;
  }
  getPremiumAIGenericFields() {
    return _allAIOCRGenericFields;
  }
  getPremiumAIFields() {
    return _premiumAIFields;
  }
  getNewGenericField() {
    return _newGenericField;
  }
  getCurrentMonthRequestCount() {
    return _currentMonthRequestCount;
  }
  lastChange() {
    return _lastChange;
  }
}
const store = new AIOCRStore();
Dispatcher.register((action) => {
  _lastChange = action.actionType;
  switch (action.actionType) {
    case actionTypes.GetPremiumAIGenericFields:
      _lastChange = actionTypes.GetPremiumAIGenericFields;
      _allAIOCRGenericFields = action.Result;
      store.emitChange();
      break;
    case actionTypes.GetPremiumAIFields:
      _lastChange = actionTypes.GetPremiumAIFields;
      _premiumAIFields = action.Result;
      store.emitChange();
      break;
    case actionTypes.UpdatePremiumAIFields:
      _lastChange = actionTypes.UpdatePremiumAIFields;
      store.emitChange();
      break;
    case actionTypes.AddPremiumAIGenericField:
      _lastChange = actionTypes.AddPremiumAIGenericField;
      _newGenericField = action.Result;
      store.emitChange();
      break;
    case actionTypes.DeletePremiumAIGenericField:
      _lastChange = actionTypes.DeletePremiumAIGenericField;
      store.emitChange();
      break;
    case actionTypes.GetPremiumAICurrentMonthRequestCount:
      _lastChange = actionTypes.GetPremiumAICurrentMonthRequestCount;
      _currentMonthRequestCount = action.Result;
      store.emitChange();
      break;
    default:
  }
});
export default store;
